<template>
    <main-container title="Results">
        <div class="warning text-center my-2">CAUTION: ALWAYS MAINTAIN THE CORRECT INFLATION FOR THE TIRE LOAD</div>

        <table class="results table">
            <tr class="header">
                <th colspan="2">Recommended Tire Pressure</th>
            </tr>
            <tr>
                <td class="pressure" colspan="2">{{ psi }} PSI / {{ kpa }} KPA</td>
            </tr>
            <tr class="header">
                <th colspan="2">Application Details</th>
            </tr>
            <tr>
                <th>Application</th>
                <td>{{ applicationText }}</td>
            </tr>
            <tr>
                <th>Speed</th>
                <td>{{ applicationSpeed }}</td>
            </tr>
            <tr class="header">
                <th colspan="2">Tire Details</th>
            </tr>
            <tr>
                <th>Tire Size</th>
                <td>{{ size }}</td>
            </tr>
            <tr>
                <th>Load Index</th>
                <td>{{ data.loadIndex }}</td>
            </tr>
            <tr>
                <th>Axle Weight</th>
                <td>{{ data.axleWeight | numeral('0,0')}}</td>
            </tr>
            <tr>
                <th>Max Weight</th>
                <td>{{ maxLbs | numeral('0,0') }} lbs / {{ maxKg | numeral('0,0') }} Kg</td>
            </tr>
            <tr>
                <th>Tires</th>
                <td>{{ quantityText }}</td>
            </tr>
            <tr>
                <th>Tire Type</th>
                <td>{{ typeText }}</td>
            </tr>
        </table>

        <router-link :to="{name: 'home'}" exact class="btn btn-primary btn-block">
            Recalculate
        </router-link>

        <div class="tiny-text my-1 text-center">Recommended tire inflation pressure – This is the recommended tire inflation pressure based on data from the US Tire and Rim Association.</div>
    </main-container>
</template>

<script>
import Vuex from 'vuex'
import MainContainer from '@/components/main-container'

export default {
    name: 'result',
    components: {
        MainContainer,
    },
    data: () => ({}),
    computed: {
        ...Vuex.mapState(['data']),
        ...Vuex.mapGetters([
            'hasValidCalculations',
            'psi',
            'kpa',
            'maxLbs',
            'maxKg',
            'applicationText',
            'applicationSpeed',
            'size',
            'quantityText',
            'typeText',
        ]),
    },

    methods: {},

    created () {
        if (!this.hasValidCalculations) {
            this.$router.push({ name: 'home' })
        }
    },
}
</script>
